export function groupBy(a: any, f: any) {
    return a.reduce(function (rv: any, x: any) {
        const key = f(x);
        (rv[key] = rv[key] || []).push(x);
        return rv;
    }, {});
}
